import React from "react";
import ResultFormPage from "../components/results/ResultFormPage";

const ResultCreate = () => <ResultFormPage mode="create" />;

export default ResultCreate;
